import React, { useContext } from "react";
import { RiThumbUpLine, RiHeartFill, RiStarFill } from "react-icons/ri";
import "./thankYou.scss"; // Import your CSS file
import ThemeSelectorContext from "../../services/context/ThemeSelectorContext";
import AppointmentDetails from "../appointmentDetails";
import FormRendererContext from "../../services/context/FormRendererContext";

const ThankYouPage = () => {
  const { theme } = useContext(ThemeSelectorContext);
  const { thankYouMessage, journeyConfigsGlobal } =
    useContext(FormRendererContext);

  // Extract thankYouPage config
  const thankYouConfig = journeyConfigsGlobal?.thankYouPage;
  const isHtmlContent = thankYouConfig?.isHtml;
  const htmlContent = thankYouConfig?.htmlContent;

  return (
    <>
      {theme && theme !== "theme2" ? (
        <div className="thankyou-container h-screen bg-gray-100 py-48">
          <div className="max-w-[700px] m-auto">
            {thankYouMessage && thankYouMessage !== "" ? (
              // Priority 1: Render thankYouMessage if available
              <>
                <h1>Thank You!</h1>
                <p>{thankYouMessage}</p>
              </>
            ) : isHtmlContent && htmlContent ? (
              // Priority 2: Render HTML content when thankYouMessage is not available
              <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            ) : (
              // Priority 3: Render default content as fallback
              <>
                <h1>Thank You!</h1>
                <p>
                  We appreciate your time and effort. Your submission has been
                  received.
                </p>

                {/* <div className="icons">
                  <RiThumbUpLine className="icon" />
                  <RiHeartFill className="icon" />
                  <RiStarFill className="icon" />
                </div> */}
              </>
            )}
          </div>
        </div>
      ) : (
        <AppointmentDetails />
      )}
    </>
  );
};

export default ThankYouPage;
